module.exports = __webpack_public_path__ + "assets/img/101200.d411f348.png";